
import axiosInstanceApi from "@/plugins/axios";

export class BaseApiService {
  header
  constructor(notifier, callback) {
    this.header = axiosInstanceApi.defaults.headers
    if (!axiosInstanceApi.$notifier) {
      axiosInstanceApi.$notifier = notifier;
    }
    if (!axiosInstanceApi.$callback) {
      axiosInstanceApi.$callback = callback;
    }
  }
}

export class ReadOnlyApiService extends BaseApiService {
  #resource;
  constructor(resource, notifier, callback) {
    
    super(notifier, callback)
    this.#resource = resource;
  }

  async get(pointer = '', params = {}) {
    let resource = this.#resource
    if (pointer.length !== 0) resource += `/${pointer}`
    const err = (e) => {
      console.log(`${e} ресурс : ${resource}`);
      return {
        data: []
      }
    }

    if (typeof params !== 'object') params = {} 
    const { data } = await axiosInstanceApi.get(resource, {params: params}).catch(err);
    // console.log(resource)
    // console.log(data)
    return data;
  }
}

export class CrudApiService extends ReadOnlyApiService {
  #resource;
  constructor(resource, notifier, callback) {
    super(resource, notifier, callback);
    this.#resource = resource;
  }

  async post(pointer = '',entity) {
    let resource = this.#resource
    if (pointer.length !== 0) resource += `/${pointer}`
    const err = (e) => {
      console.log(`${e} ресурс : ${resource}`);
      return {
        data: []
      }
    }
    const { data } = await axiosInstanceApi.post(resource, entity).catch(err);
    return data;
  }

  async put(entity) {
    const { data } = await axiosInstanceApi.put(`${this.#resource}/${entity.id}`, entity);
    return data;
  }

  async delete(id) {
    const { data } = await axiosInstanceApi.delete(`${this.#resource}/${id}`);
    return data;
  }
}





